import * as React from "react"
import type { SVGProps } from "react"
const SvgSignals = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7.82 2.91a10 10 0 0 1 11.77 15.6 1 1 0 1 1-1.52-1.3A8 8 0 1 0 11 19.94v-2.02a6 6 0 1 1 5.21-1.65 1 1 0 0 1-1.4-1.42A4 4 0 1 0 11 15.87v-2.14A2 2 0 0 1 12 10a2 2 0 0 1 1 3.73V21a1 1 0 0 1-1 1h-.43A10 10 0 0 1 7.82 2.9" />
  </svg>
)
export default SvgSignals
